import React, {useEffect, useState} from "react";
import {useTranslation} from "next-i18next";
import {useAppDispatch, useAppSelector} from "../../app/hooks";
import {
  fetchAffiliates,
  selectAffiliates,
  selectError,
  selectIsLoadingAffiliates,
  reset
} from "../../redux/affiliate/affiliateAdminSlice";
import {ApiError} from "../../errors/apiError";
import {RealmServiceError} from "../../errors/realmServiceError";
import {Container} from "../containers/Container";
import {StoreEmptyStateView} from "../storeFeed/StoreEmptyStateView";
import {WarningColorIcon} from "../icons";
import {useRouter} from "next/router";
import {useModalRouting} from "../../utils/useModalRouting";
import {HeroHeading2} from "../text";
import Skeleton from "react-loading-skeleton";
import {AffiliateAdminTable} from "./AffiliateAdminTable";

export const AffiliateAdminView: React.FC<any> = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const router = useRouter()
  const { createRoute } = useModalRouting()

  const [pageNumber, setPageNumber] = useState(1)
  const affiliates = useAppSelector(selectAffiliates)
  const error = useAppSelector(selectError)
  const isLoadingAffiliates = useAppSelector(selectIsLoadingAffiliates)

  useEffect(() => {
    dispatch(fetchAffiliates(pageNumber))
  }, [dispatch, pageNumber])

  const emptyStateButtonTitle = error instanceof ApiError && error.code === 'UNAUTHORIZED' || error instanceof RealmServiceError && error.code === 'NOT_LOGGED_IN'
    ? t('auth:auth_title_sign_in')
    : t('store:store_empty_state_button_try_again')

  return <Container>
    <div className={`${error ? '' : 'hidden'} flex-1 flex flex-col justify-center items-center`}>
      <StoreEmptyStateView
        onClick={() => {
          if (error instanceof ApiError && error.code === 'UNAUTHORIZED' || error instanceof RealmServiceError && error.code === 'NOT_LOGGED_IN') {
            router.push(
              createRoute({ name: 'login', query: { config: 'sign_in' }, reloadOnClose: true }),
              undefined,
              { shallow: true }
            );
          } else {
            dispatch(reset())
            if (pageNumber === 1) {
              dispatch(fetchAffiliates(pageNumber))
            } else {
              setPageNumber(1)
            }
          }
        }}
        buttonTitle={emptyStateButtonTitle}
        error={error}
        icon={<WarningColorIcon />}
        isLoading={isLoadingAffiliates}
      />
    </div>

    <HeroHeading2 className={`mb-8 ${error ? 'hidden' : ''}`}>Affiliates</HeroHeading2>

    <div className={`mb-8 ${error ? 'hidden' : ''}`}>
      <AffiliateAdminTable
        affiliates={affiliates}
        onLoadMoreClicked={() => {
          setPageNumber(pageNumber + 1)
        }}
      />
    </div>
  </Container>
}